/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetMcpMetadataRequestBody,
  SetMcpMetadataRequestBody$Outbound,
  SetMcpMetadataRequestBody$outboundSchema,
} from "../components/setmcpmetadatarequestbody.js";

export type SetMcpMetadataSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetMcpMetadataSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetMcpMetadataSecurity = {
  option1?: SetMcpMetadataSecurityOption1 | undefined;
  option2?: SetMcpMetadataSecurityOption2 | undefined;
};

export type SetMcpMetadataRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setMcpMetadataRequestBody: SetMcpMetadataRequestBody;
};

/** @internal */
export type SetMcpMetadataSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetMcpMetadataSecurityOption1$outboundSchema: z.ZodMiniType<
  SetMcpMetadataSecurityOption1$Outbound,
  SetMcpMetadataSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function setMcpMetadataSecurityOption1ToJSON(
  setMcpMetadataSecurityOption1: SetMcpMetadataSecurityOption1,
): string {
  return JSON.stringify(
    SetMcpMetadataSecurityOption1$outboundSchema.parse(
      setMcpMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type SetMcpMetadataSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetMcpMetadataSecurityOption2$outboundSchema: z.ZodMiniType<
  SetMcpMetadataSecurityOption2$Outbound,
  SetMcpMetadataSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setMcpMetadataSecurityOption2ToJSON(
  setMcpMetadataSecurityOption2: SetMcpMetadataSecurityOption2,
): string {
  return JSON.stringify(
    SetMcpMetadataSecurityOption2$outboundSchema.parse(
      setMcpMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type SetMcpMetadataSecurity$Outbound = {
  Option1?: SetMcpMetadataSecurityOption1$Outbound | undefined;
  Option2?: SetMcpMetadataSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetMcpMetadataSecurity$outboundSchema: z.ZodMiniType<
  SetMcpMetadataSecurity$Outbound,
  SetMcpMetadataSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SetMcpMetadataSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SetMcpMetadataSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function setMcpMetadataSecurityToJSON(
  setMcpMetadataSecurity: SetMcpMetadataSecurity,
): string {
  return JSON.stringify(
    SetMcpMetadataSecurity$outboundSchema.parse(setMcpMetadataSecurity),
  );
}

/** @internal */
export type SetMcpMetadataRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetMcpMetadataRequestBody: SetMcpMetadataRequestBody$Outbound;
};

/** @internal */
export const SetMcpMetadataRequest$outboundSchema: z.ZodMiniType<
  SetMcpMetadataRequest$Outbound,
  SetMcpMetadataRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setMcpMetadataRequestBody: SetMcpMetadataRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      setMcpMetadataRequestBody: "SetMcpMetadataRequestBody",
    });
  }),
);

export function setMcpMetadataRequestToJSON(
  setMcpMetadataRequest: SetMcpMetadataRequest,
): string {
  return JSON.stringify(
    SetMcpMetadataRequest$outboundSchema.parse(setMcpMetadataRequest),
  );
}
